(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initCarousel(root) {
    if (!root || root.dataset.lpGrInit === 'true') return;
    root.dataset.lpGrInit = 'true';

    var viewport = root.querySelector('[data-lp-gr-viewport]');
    var track = root.querySelector('[data-lp-gr-track]');
    var prevBtn = root.querySelector('[data-lp-gr-prev]');
    var nextBtn = root.querySelector('[data-lp-gr-next]');
    if (!viewport || !track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('[data-lp-gr-item]'));
    if (items.length < 2) return;

    var autoplay = root.dataset.autoplay === 'true';
    var speedPx = parseFloat(root.dataset.autoplaySpeed) || 28;
    var reduced = prefersReducedMotion();
    if (reduced) autoplay = false;

    var offset = 0;
    var rafId = 0;
    var lastTs = 0;
    var paused = false;
    var dragging = false;
    var pointerDown = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var pointerId = null;
    var lastDragX = 0;
    var loopWidth = 0;
    var DESKTOP_DRAG_THRESHOLD = 8;
    var MOBILE_DRAG_THRESHOLD = 2;

    function isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function isTouchLikePointer(e) {
      return !!(e && e.pointerType === 'touch');
    }

    function useMobileDrag(e) {
      return isMobileViewport() || isTouchLikePointer(e);
    }

    function dragThresholdFor(e) {
      return useMobileDrag(e) ? MOBILE_DRAG_THRESHOLD : DESKTOP_DRAG_THRESHOLD;
    }

    function measure() {
      var originals = track.querySelectorAll('[data-lp-gr-item]:not([data-lp-gr-clone])');
      if (!originals.length) return;
      loopWidth = 0;
      originals.forEach(function (el) {
        loopWidth += el.getBoundingClientRect().width;
      });
      if (loopWidth <= 0) loopWidth = track.scrollWidth / 2;
    }

    function normalizeOffset() {
      if (loopWidth <= 0) return;
      while (offset <= -loopWidth) offset += loopWidth;
      while (offset > 0) offset -= loopWidth;
    }

    function applyTransform() {
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    }

    function tick(ts) {
      rafId = 0;
      if (paused || dragging || !autoplay || loopWidth <= 0) return;
      if (pointerDown && isMobileViewport()) return;
      if (!lastTs) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;
      offset -= speedPx * dt;
      normalizeOffset();
      applyTransform();
      rafId = requestAnimationFrame(tick);
    }

    function startAutoplay() {
      if (!autoplay || reduced) return;
      if (!rafId) {
        lastTs = 0;
        rafId = requestAnimationFrame(tick);
      }
    }

    function stopAutoplay() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
      lastTs = 0;
    }

    function shiftBy(deltaItems) {
      measure();
      if (loopWidth <= 0) return;
      var itemW = loopWidth / items.filter(function (n) {
        return !n.hasAttribute('data-lp-gr-clone');
      }).length;
      offset += deltaItems * itemW;
      normalizeOffset();
      applyTransform();
    }

    function cloneForLoop() {
      track.querySelectorAll('[data-lp-gr-clone]').forEach(function (n) {
        n.remove();
      });
      items = Array.prototype.slice.call(track.querySelectorAll('[data-lp-gr-item]'));
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('data-lp-gr-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(function (a) {
          a.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
      });
    }

    cloneForLoop();
    measure();
    applyTransform();
    startAutoplay();

    root.addEventListener('mouseenter', function () {
      paused = true;
      stopAutoplay();
    });
    root.addEventListener('mouseleave', function () {
      paused = false;
      startAutoplay();
    });

    root.addEventListener('focusin', function () {
      paused = true;
      stopAutoplay();
    });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) {
        paused = false;
        startAutoplay();
      }
    });

    viewport.addEventListener('keydown', function (e) {
      var key = e.key;
      if (key === 'ArrowLeft') {
        e.preventDefault();
        shiftBy(1);
      } else if (key === 'ArrowRight') {
        e.preventDefault();
        shiftBy(-1);
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        shiftBy(1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        shiftBy(-1);
      });
    }

    function beginDrag(e) {
      if (dragging) return;
      dragging = true;
      dragMoved = true;
      paused = true;
      stopAutoplay();
      dragStartOffset = offset;
      dragStartX = e.clientX;
      lastDragX = e.clientX;
      viewport.classList.add('is-dragging');
      try {
        viewport.setPointerCapture(e.pointerId);
      } catch (err) {}
    }

    function onPointerDown(e) {
      if (e.target.closest('[data-lp-gr-prev], [data-lp-gr-next]')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      pointerDown = true;
      dragging = false;
      dragMoved = false;
      pointerId = e.pointerId;
      dragStartX = e.clientX;
      dragStartOffset = offset;
      lastDragX = e.clientX;

      if (useMobileDrag(e)) {
        paused = true;
        stopAutoplay();
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
    }

    function onPointerMove(e) {
      if (!pointerDown || e.pointerId !== pointerId) return;

      var delta = e.clientX - dragStartX;
      var threshold = dragThresholdFor(e);

      if (!dragging && Math.abs(delta) >= threshold) {
        beginDrag(e);
      }
      if (!dragging) return;

      e.preventDefault();

      if (useMobileDrag(e)) {
        var dx = e.clientX - lastDragX;
        lastDragX = e.clientX;
        offset += dx;
      } else {
        offset = dragStartOffset + (e.clientX - dragStartX);
      }
      applyTransform();
    }

    function onPointerEnd(e) {
      if (e && e.pointerId != null && pointerId != null && e.pointerId !== pointerId) return;
      endDrag(e);
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove, { passive: false });
    viewport.addEventListener('pointerup', onPointerEnd);
    viewport.addEventListener('pointercancel', onPointerEnd);

    function endDrag(e) {
      if (!pointerDown && !dragging) return;

      var didDrag = dragging;
      pointerDown = false;
      dragging = false;
      viewport.classList.remove('is-dragging');

      if (didDrag) {
        normalizeOffset();
        applyTransform();
        window.setTimeout(function () {
          dragMoved = false;
        }, 0);
      } else {
        dragMoved = false;
      }

      paused = false;
      startAutoplay();

      if (e && e.pointerId != null) {
        try {
          viewport.releasePointerCapture(e.pointerId);
        } catch (err) {}
      }
    }

    viewport.addEventListener(
      'click',
      function (e) {
        if (!dragMoved) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    track.addEventListener(
      'dragstart',
      function (e) {
        e.preventDefault();
      },
      true
    );

    window.addEventListener(
      'resize',
      function () {
        measure();
        normalizeOffset();
        applyTransform();
      },
      { passive: true }
    );

    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    mq.addEventListener('change', function () {
      reduced = mq.matches;
      if (reduced) {
        autoplay = false;
        stopAutoplay();
      } else if (root.dataset.autoplay === 'true') {
        autoplay = true;
        startAutoplay();
      }
    });
  }

  function initAll(scope) {
    var ctx = scope || document;
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-lp-global-recognition]'), initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
